Selector.View.ResultView = Backbone.View.extend(
/** @lends Selector.View.ResultView# */
{	
	/** classname to give the generated element */
	className: "e_selector_item e_selector_result",
	
	/** tagname to give this generated element */
	tagName: "div",

	/** template to use for Underscore.js rendering */
	template: _.template($('#selector_result').html()),

    events: {
        "click .e_selector_print": 	"printResults"
    },

    initialize: function(options) {
        var _this = this;

        _.bindAll(this, "render");
        _.bindAll(this, "fetchProduct");
        // Listen only for changes to the 'results' attribute in the model
        this.model.on('change:results', this.render);         
        // Listen to when fetchProduct is triggered separately
        this.model.on('fetchProduct', this.fetchProduct);
        this.setElement(options.el);
    },

    fetchProduct: function(){
	    var _this = this;
	    var result = this.model.fetchProduct();

	    if (result) {
            result.then(function(){
                ele.selector.data.fetchedData = _this.model.attributes;
            });
        }
    },

	/** Render function */
	render: function() {
        let resultsFinal = this.model.get("results");
		this.$el.html(this.template({
            resultsStart: ele.selector.data.TEXT.RESULTSSTART,
            resultsFinish: ele.selector.data.TEXT.RESULTSFINISH,
            noResultsText: ele.selector.data.TEXT.NORESULTS,
            resultText: ele.selector.data.TEXT.RESULTTITLE,
            results: resultsFinal,
            NoRelevantResultsBasedOnAnswers: this.model.get("NoRelevantResultsBasedOnAnswers")
        }));//render the HTML

        if (ele.uri.getParameterByName(window.location.href, "sendEvents")) {
            window.parent.document.dispatchEvent(new CustomEvent('resizeIframe'));
        }

		return this; //needed in order to chain rendering
	},

    printResults: function(){
	    let elems = $(".pageContainer, .e_healthcheck_result_header, .button");
        elems.hide();
        ele.print.printContent(".e_selector_results");
        elems.show();
    }

});